import { Box, alpha, styled } from '@mui/material';
import { Accordion, Card } from '@totalsoft/rocket-ui';

export const ThemedWrapper = styled(Box, { shouldForwardProp: prop => prop !== 'color' })(({ theme, color = 'primary' }) => ({
  color: theme.palette[color].main,
  backgroundColor: alpha(theme.palette[color].main, 0.1),
  width: '100%',
  display: 'flex',
  paddingBlock: theme.spacing(0.5),
  paddingInline: theme.spacing(2),
  borderRadius: '10px'
}));

export const DetatchedAccordion = styled(Accordion)(({ theme }) => ({
  boxShadow: theme.shadows[3],
  margin: '0 !important',
  '&::before': {
    display: 'none'
  }
}));

export const LoadingCard = styled(Card)(({ theme }) => ({
  boxShadow: theme.shadows[3],
  margin: '0 !important',
  '&::before': {
    display: 'none'
  }
}));
